import * as React from 'react';
import intl from 'react-intl-universal';
import Icon from 'components/Common/Icon';
import * as styles from './DownloadToasts.scss';
import { useDispatch } from 'react-redux';
import downloadNotificationActions from 'actions/downloadNotificationActions';

export default () => {
  const dispatch = useDispatch();
  const handleCloseClick = () => dispatch(downloadNotificationActions.dismissDownloadNotification());
  return (
    <div className={styles.container}>
      <div className={styles.iconContainer}>
        <Icon classes={['icon-loader']}/>
      </div>
      <div className={styles.messageContainer}>{intl.get('fileReadySoon')}</div>
      <button className={styles.closeButton} onClick={handleCloseClick}>
        <Icon classes={['icon-cancel']} />
      </button>
    </div>
  );
};
